<template>
  <div class="evaluation-modal" v-show="finishLoading && startAnimitionShapeTwo">
    <div class="modal-card" :class="{ 'modal-appear': showModalAppear }">
      <!-- Header -->
      <h3 class="modal-title">طلب تقييم جديد</h3>
      
      <!-- Body Text -->
      <p class="modal-description">
        تم ترشيحك لتقييم تجربة مستخدم الموقع اضغط "موافق" للاطلاع أو "رفض" للاعتذار
      </p>
      
      <!-- Buttons Container -->
      <div class="buttons-container">
           
        <!-- Agree Button -->
        <button  aria-hidden="true" tabindex="-1" class="btn btn-agree" ref="agreeButton" :class="{ 'clicked': isAgreeClicked, 'pulse': showPulseEffect }">
          <span v-if="!isAgreeClicked">موافق</span>
          <span v-else class="success-text"><svg width="32" height="32" viewBox="0 0 24 24"
                            fill="none" xmlns="http://www.w3.org/2000/svg" class="check-icon">
                            <circle cx="12" cy="12" r="12"  />
                            <path d="M9 12L11 14L15 10" stroke="white"  />
                        </svg> </span>
          <!-- Click Effect for Agree Button -->
          <div class="button-click-effect" :class="{ 'active': showButtonClickEffect }">
            <div class="click-circle circle-1"></div>
            <div class="click-circle circle-2"></div>
          </div>
          <!-- Particle Effect -->
          <div class="particle-effect" :class="{ 'active': showParticleEffect }">
            <div class="particle particle-1"></div>
            <div class="particle particle-2"></div>
            <div class="particle particle-3"></div>
            <div class="particle particle-4"></div>
            <div class="particle particle-5"></div>
            <div class="particle particle-6"></div>
          </div>
        </button>
        <!-- Reject Button -->
        <button class="btn btn-reject" aria-hidden="true" tabindex="-1">
          رفض
        </button>
     
      </div>
      
      <!-- Arrow Icon -->
      <div class="arrow-icon">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 2L10 6L6 10" stroke="#5854FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, watch } from 'vue'
const props = defineProps({
  startAnimitionShapeTwo: {
        type: Boolean,
        required: true
    }
})
const startAnimationRun = ref(false)

const startAnimitionShapeOne = computed(() => props.startAnimitionShapeTwo)
watch(startAnimitionShapeOne, (newVal) => {
    if(newVal){
      startAnimationSequence()
    }else{
      startAnimationRun.value = false
    }
})
// Animation state variables
const finishLoading = ref(false)
const showModalAppear = ref(false)
const showButtonClickEffect = ref(false)
const showPulseEffect = ref(false)
const showParticleEffect = ref(false)
const isAgreeClicked = ref(false)
const agreeButton = ref<HTMLElement>()

// Animation sequence function
const startAnimationSequence = async () => {
  if(!startAnimitionShapeOne.value || startAnimationRun.value){
    return
  }
  startAnimationRun.value = true
  // Step 1: Show modal with beautiful appear animation
  await new Promise(resolve => setTimeout(resolve, 200))
  showModalAppear.value = true
  
  // Step 2: Wait for modal to fully appear (1.2s)
  
  // Step 3: Add pulse effect to draw attention
  showPulseEffect.value = true
  await new Promise(resolve => setTimeout(resolve, 1000))
  
  // Step 4: Show button click effect and immediately show success
  showButtonClickEffect.value = true
  showPulseEffect.value = false
  
  // Step 5: Wait for click animation to complete (0.6s)
  await new Promise(resolve => setTimeout(resolve, 600))
  
  // Step 6: Show success state with particles
  showButtonClickEffect.value = false
  isAgreeClicked.value = true
  showParticleEffect.value = true
  
  // Step 7: Wait for particle animation to complete (1s)
  await new Promise(resolve => setTimeout(resolve, 1000))
  
  // Step 8: Hide particle effect
  showParticleEffect.value = false
  
  // Step 9: Wait 2 seconds after animation completion
  await new Promise(resolve => setTimeout(resolve, 200))
  showModalAppear.value = false
  await new Promise(resolve => setTimeout(resolve, 1000))
  // Step 10: Reset to initial state
  await resetToInitialState()
  
  // Animation cycle is complete - no restart here
  startAnimationSequence()
}

// Function to reset all elements to initial state
const resetToInitialState = async () => {
  //showModalAppear.value = false
  showButtonClickEffect.value = false
  showPulseEffect.value = false
  showParticleEffect.value = false
  isAgreeClicked.value = false
  // Wait for reset to complete
  await new Promise(resolve => setTimeout(resolve, 300))
}

// Start animation when component mounts
onMounted(() => {
  finishLoading.value = true
  
 
})
</script>

<style scoped>
/* Modal Appear Animation */
.modal-card {
  opacity: 0;
  transform: scale(0.8) translateY(50px);
  filter: blur(10px);
  transition: all .3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.modal-card.modal-appear {
  opacity: 1;
  transform: scale(1) translateY(0);
  filter: blur(0);
}

/* Button Click Effect */
.btn-agree {
  position: relative;
}

.button-click-effect {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: 10;
}

.button-click-effect .click-circle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 2px solid #b6b6b6;
  border-radius: 50%;
  opacity: 0;
}

.button-click-effect .circle-1 {
  width: 20px;
  height: 20px;
}

.button-click-effect .circle-2 {
  width: 20px;
  height: 20px;
}

.button-click-effect.active .circle-1 {
  animation: expand-circle-1 0.6s ease-out forwards;
}

.button-click-effect.active .circle-2 {
  animation: expand-circle-2 0.6s ease-out forwards;
}

@keyframes expand-circle-1 {
  0% {
    width: 20px;
    height: 20px;
    opacity: 1;
  }
  100% {
    width: 60px;
    height: 60px;
    opacity: 0;
  }
}

@keyframes expand-circle-2 {
  0% {
    width: 20px;
    height: 20px;
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    width: 80px;
    height: 80px;
    opacity: 0;
  }
}

.evaluation-modal {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.modal-card {
  position: relative;
  width: 218px;
  height: 159px;
  background: #FFFFFF;
  border: 1px solid rgba(238, 238, 238, 0.933333);
  border-radius: 11.88px;
  padding: 17px 13px;
  box-sizing: border-box;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.modal-title {
  
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: #000000;
  margin: 0 0 14px 0;
  width: 80px;
  height: 18px;
}

.modal-description {
  
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #000000;
  margin: 0 0 20px 0;
  width: 193px;
  height: 36px;
  text-align: center;
}

.buttons-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 11px;
  width: 125px;
  height: 24px;
}

.btn {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 3px 13px;
  gap: 16px;
  width: 57px;
  height: 24px;
  border-radius: 8px;
  
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.btn-reject {
  border: 1px solid #1A0F91;
  background: #FFFFFF;
  color: #1A0F91;
}

.btn-reject:hover {
  background: #F8F7FF;
}

.btn-agree {
    background: #0D0757;
    color: #FFFFFF;
    transition: all 0.3s ease;
}

.btn-agree:hover {
    background: #1A0F91;
}

.btn-agree.clicked {
    background: #4CAF50;
    color: #FFFFFF;
    transform: scale(0.95);
    box-shadow: 0 0 20px rgba(76, 175, 80, 0.6);
    transition: all 0.3s ease;
}

.btn-agree.pulse {
    animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
    0% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(13, 7, 87, 0.4);
    }
    50% {
        transform: scale(1.03);
        box-shadow: 0 0 0 8px rgba(13, 7, 87, 0);
    }
    100% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(13, 7, 87, 0);
    }
}

.success-text {
    font-size: 16px;
    font-weight: bold;
    animation: successAppear 0.5s ease-out;
    margin-bottom: -2px;
}

@keyframes successAppear {
    0% {
        opacity: 0;
        transform: scale(0.5) ;
    }
    50% {
        opacity: 0.7;
        transform: scale(1.2);
    }
    100% {
        opacity: 1;
        transform: scale(1) ;
    }
}

/* Particle Effect */
.particle-effect {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    z-index: 15;
}

.particle {
    position: absolute;
    width: 4px;
    height: 4px;
    background: #4CAF50;
    border-radius: 50%;
    opacity: 0;
}

.particle-effect.active .particle-1 {
    animation: particle1 1s ease-out forwards;
}

.particle-effect.active .particle-2 {
    animation: particle2 1s ease-out forwards;
}

.particle-effect.active .particle-3 {
    animation: particle3 1s ease-out forwards;
}

.particle-effect.active .particle-4 {
    animation: particle4 1s ease-out forwards;
}

.particle-effect.active .particle-5 {
    animation: particle5 1s ease-out forwards;
}

.particle-effect.active .particle-6 {
    animation: particle6 1s ease-out forwards;
}

@keyframes particle1 {
    0% {
        opacity: 1;
        transform: translate(0, 0) scale(1);
    }
    100% {
        opacity: 0;
        transform: translate(-30px, -30px) scale(0);
    }
}

@keyframes particle2 {
    0% {
        opacity: 1;
        transform: translate(0, 0) scale(1);
    }
    100% {
        opacity: 0;
        transform: translate(30px, -30px) scale(0);
    }
}

@keyframes particle3 {
    0% {
        opacity: 1;
        transform: translate(0, 0) scale(1);
    }
    100% {
        opacity: 0;
        transform: translate(-30px, 30px) scale(0);
    }
}

@keyframes particle4 {
    0% {
        opacity: 1;
        transform: translate(0, 0) scale(1);
    }
    100% {
        opacity: 0;
        transform: translate(30px, 30px) scale(0);
    }
}

@keyframes particle5 {
    0% {
        opacity: 1;
        transform: translate(0, 0) scale(1);
    }
    100% {
        opacity: 0;
        transform: translate(0, -40px) scale(0);
    }
}

@keyframes particle6 {
    0% {
        opacity: 1;
        transform: translate(0, 0) scale(1);
    }
    100% {
        opacity: 0;
        transform: translate(0, 40px) scale(0);
    }
}

.arrow-icon {
  position: absolute;
  left: 79.4%;
  right: 20.47%;
  top: 74.27%;
  bottom: 24.66%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .modal-card {
    width: 90%;
    max-width: 218px;
    height: auto;
    min-height: 159px;
  }
  
  .modal-description {
    width: 100%;
    height: auto;
  }
}
</style>
